// The report param a question's open rows are stored under (`cb`): the positions of the rows the
// reader opened, sorted and joined with dots ("1.3.4"). One grammar for every question type that
// opens rows, so a stored value reads the same whichever type wrote it; which rows a type can open
// is its own choice, passed in.

// The stored rows as the string the state holds; nothing stored is no row open.
export const decodeUncollapsedParam = section => (null == section ? '' : String(section))

// The section to write; no row open is no param at all.
export const calcCollapseSection = uncollapsed => ({ cb: uncollapsed?.length ? uncollapsed : null })

// The open rows as positions, from the stored string or an array of them.
export const calcUncollapsedKeys = uncollapsed => {
  if (Array.isArray(uncollapsed)) return uncollapsed.map(String)

  if ('string' === typeof uncollapsed && 0 < uncollapsed.length) {
    return uncollapsed.split('.').filter(value => 0 < value.length)
  }

  return []
}

// One row opened or closed.
export const calcToggledUncollapsed = (uncollapsed, position, collapsed) => {
  const open = new Set(calcUncollapsedKeys(uncollapsed))

  if (collapsed) open.delete(String(position))
  else open.add(String(position))

  return [...open].sort().join('.')
}

// Every row the type can open, or none.
export const calcAllUncollapsed = (positions = [], collapse) => (collapse ? '' : positions.map(String).sort().join('.'))

// The stored rows less those the type can no longer open; with nothing to check against, all kept.
export const calcKeptUncollapsed = (uncollapsed, keep) =>
  keep?.length
    ? calcUncollapsedKeys(uncollapsed)
        .filter(position => keep.includes(position))
        .join('.')
    : uncollapsed

// Of `[position, value]` entries, the ones whose row is open: an export hands over only the rows the
// reader has open, since a row opened and closed again keeps its registration.
export const calcOpenEntries = (entries, uncollapsed) => {
  const open = new Set(calcUncollapsedKeys(uncollapsed))

  return entries.filter(([position]) => open.has(String(position)))
}
